import React, {Component} from 'react'
import { connect } from "react-redux"

import {
    eshopId, godProjectId, isGodModeOn, projectId,
    superadminGetProductIdsLike,
    superadminGetProjects,
    superadminGetTemplates,
    superadminGetTemplatesIdsLike,
} from "app/helpers/api";

import {Autocomplete, css, Grid, GridCell, Icon, Section, Select, Spinner, Theme} from "@bdfx/mergado-ui-kit";

import trans from "trans";
import _find from "lodash/find";
import {Item} from "@bdfx/mergado-ui-kit/lib/components/Form/Autocomplete";
import toastFactory from "app/helpers/toast_factory";
import {GENERAL_ERROR} from "template-edit/reducers";
import {createToast} from "actions";
import {TemplateType} from "../components/project-info";
import {RouterType, withRouter} from "app/components/routes";
import {iconDisabledColor} from "template-edit/components/tools-panel";
import {AxiosResponse} from "axios";
import {CustomTemplateOption} from "products/components/filters";
import { getTemplateTypeColor, getTemplateTypeTranslated, getTemplateTypeIcon } from 'template-list/template-badges';
import { Project } from 'app/types/model-types';

interface Props {
    router: RouterType
    selectedProjectId: number
    selectedTemplateId: number
    selectedProductId: number
    createToast: typeof createToast
    setTemplateId: Function
    setProjectId: Function
    setProductId: Function
}

interface State {
    projects: Project[]
    templates: TemplateType[]
    autocompleteItems: Item[]
    autocompleteTemplateItems: Item[]
    isLoading: boolean
    rulesStarted: boolean
}

class SelectProject extends Component<Props, State> {
    constructor(props) {
        super(props)
        this.state = {
            projects: null,
            templates: null,
            autocompleteItems: [],
            autocompleteTemplateItems: [],
            isLoading: false,
            rulesStarted: false,
        }
    }

    componentDidMount() {
        superadminGetProjects()
            .then((response: AxiosResponse<any>) => {
                this.setState({projects: response.data})
            })
            .catch(e => {
                this.props.createToast(toastFactory(GENERAL_ERROR, e))
            })

        this.handleSelectProjectId(isGodModeOn && godProjectId ? godProjectId : projectId)
    }

    onSearch =  (phrase, option) => typeof option.name === "string" ? option.name.toLowerCase().indexOf(phrase.toLowerCase()) !== -1 : true
    highlightTextGetter = item => typeof item.name === "string" ? item.name : "-"

    handleSelectProjectId = (selectedProjectId : number) => {
        if (selectedProjectId) {
            superadminGetTemplates(selectedProjectId)
                .then((response: any) => {
                    this.setState({
                        templates: response.data,
                    })

                    //select first
                    if (Array.isArray(response.data.templates) && response.data.templates.length > 0) {
                        const templateId = parseInt(response.data.templates[0].id ?? null)
                        this.props.setProjectId(selectedProjectId)
                        this.props.setTemplateId(templateId)
                        this.props.setProductId(null)
                        this.getAutocompleteProductsValues('', selectedProjectId, templateId)
                    } else {
                        this.getAutocompleteProductsValues('', selectedProjectId, 0)
                    }
                })
                .catch(e => {
                    this.props.createToast(toastFactory(GENERAL_ERROR, e))
                })
                .finally(() => this.setState({isLoading: false}))
        } else {
            this.props.setTemplateId(null)
            this.props.setProductId(null)
            this.props.setProductId(null)
        }

        this.setState({
            isLoading: true,
            templates: null
        })

        this.props.setProjectId(selectedProjectId)
        this.props.setTemplateId(null)
        this.props.setProductId(null)
    }

    handleSelectTemplateId = (selectedTemplateId : number) => {
        this.props.setTemplateId(selectedTemplateId)
        this.props.setProductId(null)
    }

    getAutocompleteProductsValues = (selectedProductId: string = '', selectedProjectId: number = 0, selectedTemplateId: number = 0) => {
        superadminGetProductIdsLike(`${selectedProductId}`, parseInt(`${selectedProjectId}`), parseInt(`${selectedTemplateId}`))
            .then((response: any) => {
                const autocompleteItems = response.data.match.map((o) => {
                    return {label: `${o.id}`, value: `${o.id}`};
                })
                this.setState({autocompleteItems: autocompleteItems})
            })
            .catch(e => {
                console.error('error while getting products ids', e.data)
                this.props.createToast(toastFactory(GENERAL_ERROR, e))
            })

        return []
    }

    getAutocompleteTemplatesValues = (searchString: string = '') => {
        superadminGetTemplatesIdsLike(`${searchString}`)
            .then((response: any) => {
                const autocompleteTemplateItems = response.data.match.map((o) => {
                    return {label: `${o.id}_${o.project_id}`, value: `${o.id} (${o.project_id})`, title: `${o.id} (project ${o.project_id})`};
                })
                this.setState({autocompleteTemplateItems: autocompleteTemplateItems})
            })
            .catch(e => {
                console.error('error while getting template ids', e.data)
                this.props.createToast(toastFactory(GENERAL_ERROR, e))
            })

        return []
    }

    render() {
        const {selectedProjectId, selectedTemplateId, selectedProductId} = this.props
        const {projects, templates, autocompleteItems, autocompleteTemplateItems} = this.state

        const availableProjects = projects ? projects.map((p : Project) => {
            return {
                label: `${p.shop_name} (${p.id}): ${p.name} (${p.products_count} products)`,
                value: `${p.id}`,
            }
        }) : null

        const availableTemplates = templates ? templates.map((t: TemplateType) => {
            const template = t.template
            const text = getTemplateTypeTranslated(template.type)
            const color = getTemplateTypeColor(template.type)
            const icon = getTemplateTypeIcon(template.type, 20, color)

            return {
                text: <Grid cols={'auto 24px'} style={{width: '100%'}}>
                    <GridCell title={`${template.name} (${t.id})`}>{template.name}</GridCell>
                    <GridCell title={text}>{icon}</GridCell>
                </Grid>,
                label: `${template.name}`,
                value: `${template.id}`,
                active: template.active,
            }
        }) : null

        const currentTemplate = selectedTemplateId && Array.isArray(templates) ? _find(templates, (template: TemplateType) => {
            return parseInt(`${template.id}`) === parseInt(`${selectedTemplateId}`)
        }) : null

        const currentProject = selectedProjectId && Array.isArray(projects) ? _find(projects, (project: Project) => {
            return parseInt(`${project.id}`) === parseInt(`${selectedProjectId}`)
        }) : null

        return <StyledSection
            header={
                (currentProject ? `${selectedProjectId}: ${currentProject.name} ${currentProject.shop_name}` : 'Select project') +
                (currentTemplate ? `, ${currentTemplate.template.name} (${currentTemplate.id}) with ${currentTemplate.products} product(s)` : '')
            }
            color="red"
            prefix={<StyledButton onClick={() => this.props.router.navigate(`/eshop/${eshopId}/project/${projectId}`)}><Icon name="IconChevronLeft" />{trans('back')}</StyledButton>}
            suffix={<StyledSuffixGrid>
                <GridCell>
                    <Autocomplete
                        items={autocompleteItems}
                        onChange={(e) => {
                            this.props.setProductId(parseInt(e))
                            const templateId = currentTemplate ? currentTemplate.id : 0
                            this.getAutocompleteProductsValues(e, selectedProjectId, templateId)

                        }}
                        onSelected={(productId) => this.props.setProductId(parseInt(productId))}
                        value={selectedProductId ? `${selectedProductId}` : ''}
                        onClear={() => {
                            this.setState({autocompleteItems: []})
                            this.props.setProductId(null)
                            const templateId = currentTemplate ? currentTemplate.id : 0
                            this.getAutocompleteProductsValues('', selectedProjectId, templateId)
                        }}
                        placeholder={'product id'}
                    />
                </GridCell>
                <GridCell>
                    {availableProjects ?
                        <StyledSelect
                            options={availableProjects}
                            value={`${selectedProjectId}`}
                            onChange={this.handleSelectProjectId}
                            search={true}
                            highlightTextGetter={this.highlightTextGetter}
                            onSearch={this.onSearch}
                        /> : <div style={{textAlign: 'center', color: '#fff'}}>getting projects <Spinner type={'bubbles'} /></div>
                    }
                </GridCell>
                <GridCell>
                    {availableTemplates ?
                    <StyledSelect
                        key={'t'+selectedProjectId+(templates.length || 0)}
                        options={availableTemplates}
                        OptionComponent={CustomTemplateOption}
                        value={`${selectedTemplateId || ''}`}
                        onChange={this.handleSelectTemplateId}
                        search={true}
                        highlightTextGetter={this.highlightTextGetter}
                        onSearch={this.onSearch}
                    /> :
                        <Autocomplete
                            items={autocompleteTemplateItems}
                            onChange={(e) => {
                                this.getAutocompleteTemplatesValues(e)
                            }}
                            onSelected={(e) => {
                                const selected = e.split('_')
                                this.handleSelectTemplateId(parseInt(selected[0]))
                                this.handleSelectProjectId(parseInt(selected[1]))
                            }}
                            value={selectedTemplateId ? `${selectedTemplateId}` : ''}
                            onClear={() => {
                                this.getAutocompleteTemplatesValues('')
                                this.setState({autocompleteTemplateItems: []})
                                this.handleSelectTemplateId(null)
                            }}
                            placeholder={'template id (no project selected)'}
                        />
                    }
                </GridCell>
            </StyledSuffixGrid>}
        >
        </StyledSection>
    }
}

const StyledSection = css(Section)({
    ' .m-header': {
        gridTemplateColumns: 'max-content auto 50%',
        alignSelf: 'center',
        '@media screen and (max-width: 800px)': {
            gridTemplateColumns: 'auto',
        },
    },
    ' .m-prefix': {
        height: 'auto',
    },
    ' .m-header-content': {
        fontSize: '18px',
        '@media screen and (max-width: 800px)': {
            padding: '0 !important',
        },
    },
    ' .m-suffix': {
        color: '#000',
        textAlign: 'left',
        '@media screen and (max-width: 800px)': {
            padding: '0 !important',
            margin: 0,
        },
    },
    ' h2': {
        padding: '25px 0',
    },
    ' .m-content': {
        padding: 0,
    },
})

const StyledButton = css('span')({
    cursor: 'pointer',
})

const StyledSelect = css(Select)({
    marginBottom: 0,
    textAlign: 'left',
    width: '100%',
    ' .template-inactive': {
        textDecoration: 'line-through',
        fontStyle: 'italic',
        color: iconDisabledColor,
    }
})

const StyledSuffixGrid = css(Grid)({
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: '8px',
    '@media screen and (max-width: 800px)': {
        gridTemplateColumns: 'auto',
        ' input.m-textinput-input': {
            width: 'calc(100% - 10px)',
            paddingLeft: '5px',
        }
    },
})

function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps, {
    createToast,
})(withRouter(SelectProject))